exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: graphik, sans-serif;\n  background-color: #fff;\n}\n#index__root___1GpT7 {\n  overflow-x: hidden;\n}\nimg {\n  max-width: 100%;\n}\np {\n  font-size: 1em;\n  line-height: 1.6em;\n}\n", ""]);

// exports
exports.locals = {
	"root": "index__root___1GpT7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/index.styl
// module id = 247
// module chunks = 0